import { __decorate, __metadata } from "tslib";
import { ApiProperty } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { ReadLoyaltyTransactionDto } from '../../transaction';
import { LoyaltyUserStatusExposeGroup } from '../interface';
export class ReadLoyaltyUserStatusDto {
}
__decorate([
    Expose({ groups: [LoyaltyUserStatusExposeGroup.READ] }),
    Type(() => ReadLoyaltyTransactionDto),
    ApiProperty({ isArray: true, type: () => ReadLoyaltyTransactionDto }),
    __metadata("design:type", Array)
], ReadLoyaltyUserStatusDto.prototype, "activeTransactions", void 0);
__decorate([
    Expose({ groups: [LoyaltyUserStatusExposeGroup.READ] }),
    Type(() => ReadLoyaltyTransactionDto),
    ApiProperty({ isArray: true, type: () => ReadLoyaltyTransactionDto }),
    __metadata("design:type", Array)
], ReadLoyaltyUserStatusDto.prototype, "allTransactions", void 0);
__decorate([
    Expose({ groups: [LoyaltyUserStatusExposeGroup.READ] }),
    ApiProperty({ type: () => Number }),
    __metadata("design:type", Number)
], ReadLoyaltyUserStatusDto.prototype, "availablePoints", void 0);
__decorate([
    Expose({ groups: [LoyaltyUserStatusExposeGroup.READ] }),
    ApiProperty({ type: () => String }),
    __metadata("design:type", String)
], ReadLoyaltyUserStatusDto.prototype, "merchantId", void 0);
__decorate([
    Expose({ groups: [LoyaltyUserStatusExposeGroup.READ] }),
    ApiProperty({ type: () => String }),
    __metadata("design:type", String)
], ReadLoyaltyUserStatusDto.prototype, "userId", void 0);
__decorate([
    Expose({ groups: [LoyaltyUserStatusExposeGroup.READ] }),
    ApiProperty({ type: () => String }),
    __metadata("design:type", String)
], ReadLoyaltyUserStatusDto.prototype, "programUuid", void 0);
//# sourceMappingURL=ReadLoyaltyUserStatusDto.js.map